<template>
    <div>
        <skupovi-navigation
                :id="skup_id"
                :breadcrumbs="breadcrumbs"
        >
        </skupovi-navigation>
        <div class="ibox ">
            <div class="ibox-title">
                <h5>Webinari</h5><br>
                <button
                        type="button"
                        class="btn btn-lg btn-primary"
                        @click.prevent="create"
                >
                    Novi unos
                </button>
            </div>
            <div class="ibox-content">
                <datatables
                        v-if="show_datatable"
                        :url="datatables_url"
                        :settings="datatables.settings"
                        :title="datatables.title"
                        @rowClick="rowClick"
                >
                </datatables>
            </div>
        </div>
    </div>

</template>

<script>

import Datatables from "@/components/datatable/Datatables";
import SkupoviNavigation from "@/views/pages/Skupovi/SkupoviNavigation";
import axios from "axios";

export default {
    name: "Webinars",
    components: {
        Datatables,
        SkupoviNavigation
    },
    data(){
        return {
            show_datatable: false,
            datatables_url: process.env.VUE_APP_API_URL +  'webinar',
            datatables: {},
            breadcrumbs: [],
            skup_id: this.$route.params.skup_id
        }

    },
    methods:{
        rowClick( row ){
            this.$router.push( { path: '/skupovi/' + this.skup_id + '/webinari/' + row.id } )
        },

        create(){
            this.$router.push( { path: '/skupovi/' + this.skup_id + '/webinari/create' } )
        },

        setDatatable() {
            let vm = this;
            vm.datatables = {
                settings: {
                    table_header:[
                        {
                            'id': 'id',
                            'visible': false,
                        },
                        {
                            'id': 'skup_id',
                            'visible': false,
                            'filter':{
                                'type': 'none',
                                'value': vm.skup_id
                            },
                        },
                        {
                            'id': 'naziv',
                            'title': 'Naziv',
                            'column_visibility_group': {
                                id: 'webinar',
                            }
                        },
                        {
                            'id': 'datum_od',
                            'title': 'Početak',
                            'filter': {
                                type: 'none'
                            },
                            'column_visibility_group': {
                                id: 'webinar',
                            }
                        },
                        {
                            'id': 'datum_do',
                            'title': 'Završetak',
                            'filter': {
                                type: 'none'
                            },
                            'column_visibility_group': {
                                id: 'webinar',
                            }
                        },
                        {
                            'id': 'url',
                            'title': 'Poveznica',
                            'column_visibility_group': {
                                id: 'webinar',
                            }
                        },
                        {
                            'id': 'webinar_api_provider.title',
                            'title': 'Poslužitelj',
                            'filter': {
                                'type': 'select',
                                'search': function ( ){
                                    let component = this;

                                    axios.get( process.env.VUE_APP_API_URL +  'webinar-api-provider', {
                                        params: {
                                            order: 'asc'
                                        }
                                    })
                                            .then( function ( response ) {
                                                let tmp = [];
                                                response.data.data.forEach( function ( item ) {
                                                    tmp.push({
                                                        key: item.id,
                                                        value: item.title
                                                    } );
                                                } );
                                                component.$data.tmp = tmp;
                                            } )
                                            .catch( function ( error ) {
                                                if(error instanceof Error) {
                                                    console.log( 'Error: ' . error);
                                                } else {
                                                    console.log( 'Unexpected response: ' . error);
                                                }
                                            } )
                                },
                                'value': null
                            },
                            'column_visibility_group': {
                                id: 'webinar',
                            }
                        },

                    ],
                    column_visibility_groups:{
                        'webinar' : 'Webinari'
                    },
                    order: 'desc',
                    order_by: 'id',
                },
                title: 'Webinar',
            }
            vm.show_datatable = true;
        },

        setBreadcrumbs(){
            this.breadcrumbs = [
                {
                    path: '/skupovi/' + this.skup_id + '/webinari',
                    name: 'Webinari'
                }
            ]
        }
    },
    mounted() {
        this.setDatatable()
        this.setBreadcrumbs()
    }
}
</script>

<style scoped>

</style>